import { render, staticRenderFns } from "./notificationHistory.vue?vue&type=template&id=1d881328&scoped=true"
import script from "./notificationHistory.vue?vue&type=script&lang=js"
export * from "./notificationHistory.vue?vue&type=script&lang=js"
import style0 from "./notificationHistory.vue?vue&type=style&index=0&id=1d881328&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d881328",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d881328')) {
      api.createRecord('1d881328', component.options)
    } else {
      api.reload('1d881328', component.options)
    }
    module.hot.accept("./notificationHistory.vue?vue&type=template&id=1d881328&scoped=true", function () {
      api.rerender('1d881328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/appManage/components/notificationHistory.vue"
export default component.exports